import React, { useState } from 'react';
import styled from 'styled-components';

import { Box, SelectInput } from 'vqp-common'
import { DateInput, Button, Input } from '../common'
import { TextSelect } from '../products/ProductModal'

const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding-top: 8px;
    margin-left: 8px;
    align-self: center;
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 15px;
`

const Card = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 20px;
`

const Title = styled.div`
    font-size: 15px;
    font-weight: 700;
    color: ${props => props.theme.colors.textBold}
`

const FieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: ${props => props.width || "auto"};
    padding: ${props => props.padding || "0 10px"};
`


const Label = styled.span`
    color: ${props => props.theme.colors.textPrimary};
    font-size: 14px;
`

const DateRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

const DateDivider = styled(Label)`
    padding: 0px 15px;
`

export const OrdersFilter = ({ defaultDates, onFilter, onGerarRelatorio, reportLoading }) => {

    const modalityOptionsType = [
        {
            value: 0,
            name: 'Todas'
        },
        {
            value: 1,
            name: "Comer no Local"
        },
        {
            value: 2,
            name: "Retirada",
        },
        {
            value: 3,
            name: "Entrega no Escritório",
        },
        {
            value: 4,
            name: "Delivery",
        },
    ];

    const scheduleOptionsType = [
        {
            value: 0,
            name: "Todos"
        },
        {
            value: 1,
            name: "Com agendamento"
        },
        {
            value: 2,
            name: "Sem agendamento"
        },
    ]

    const [id, setId] = useState('');
    const [initialDate, setInitialDate] = useState(defaultDates.initialDate)
    const [finalDate, setFinalDate] = useState(defaultDates.finalDate)
    const [modality, setModality] = useState(0);
    const [schedule, setSchedule] = useState(0);

    const handleInitialDateChange = (initialValue) => {
        setInitialDate(initialValue)
    }

    const handleFinalDateChange = (finalValue) => {
        setFinalDate(finalValue)
    }

    const handleIdChange = (id) => {
        setId(id);
    }

    const handleFilter = (e) => {
        e.preventDefault();
        onFilter({
            id,
            initialDate,
            finalDate,
            modality: modality !== 0 ? modality : null,
            schedule: schedule !== 0 ? schedule === 1 ? true : false : null
        })
    }

    const handleSelectModality = (modality) => {
        setModality(modality);
    }

    const handleSelectSchedule = (schedule) => {
        setSchedule(schedule);
    }


    return (
        <Wrapper>
            <Title>
                Filtros
            </Title>
            <form onSubmit={handleFilter}>
                <Card>
                    <FieldWrapper>
                        <Label>Id do pedido</Label>
                        <DateRow>
                            <Input
                                value={id}
                                onChange={handleIdChange}
                                placeholder="Digite o id do pedido..."
                            />
                        </DateRow>
                    </FieldWrapper>
                    <FieldWrapper>
                        <Label>Data</Label>
                        <DateRow>
                            <DateInput width="100px" value={initialDate} onChange={handleInitialDateChange} />
                            <DateDivider>a</DateDivider>
                            <DateInput width="100px" value={finalDate} onChange={handleFinalDateChange} />
                        </DateRow>
                    </FieldWrapper>
                    <FieldWrapper padding="0 10px 16px">
                        <Label>Modalidade</Label>
                        <TextSelect
                            minWidth={'150px'}
                            selected={modality}
                            onChange={handleSelectModality}
                            options={modalityOptionsType}
                        />
                    </FieldWrapper>
                    <FieldWrapper padding="0 10px 16px">
                        <Label>Agendamento</Label>
                        <TextSelect
                            minWidth={'150px'}
                            selected={schedule}
                            onChange={handleSelectSchedule}
                            options={scheduleOptionsType}
                        />
                    </FieldWrapper>
                    <ButtonRow>
                        <Button className="success" width={"80px"} type="submit">
                            Filtrar
                        </Button>
                        {onGerarRelatorio && (
                            <Button
                                type="button"
                                className="primary"
                                onClick={() => onGerarRelatorio({
                                    initialDate,
                                    finalDate,
                                    id: id || undefined,
                                    modality: modality !== 0 ? modality : null,
                                    schedule: schedule !== 0 ? schedule === 1 : null
                                })}
                                disabled={reportLoading}
                            >
                                {reportLoading ? 'Gerando...' : 'Gerar Relatório Personalizado'}
                            </Button>
                        )}
                    </ButtonRow>
                </Card>
            </form>
        </Wrapper>
    )
}
